export default "__VITE_ASSET__BcgBz68d__";